import { render, staticRenderFns } from "./Delivered.vue?vue&type=template&id=668e39e3&scoped=true"
import script from "./Delivered.vue?vue&type=script&lang=js"
export * from "./Delivered.vue?vue&type=script&lang=js"
import style0 from "./Delivered.vue?vue&type=style&index=0&id=668e39e3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668e39e3",
  null
  
)

export default component.exports